<ion-list lines="none">
  <ion-item tappable (click)="putSaleOnHold()" *ngIf="!sale.isRefundSale() && sale.status !== 1">Put sale on hold</ion-item>
  <ion-item tappable (click)="cancelSale()" *ngIf="sale.status === 2">Cancel sale</ion-item>
</ion-list>
